import { createFileRoute } from "@tanstack/react-router";
import { z } from "zod";
import { documentTypesQueries } from "../../../features/fsm-admin/document-types/api/document-types.queries";
import { statesQueries } from "../../../features/fsm-admin/states/api/states.queries";
import { customersQueries } from "../../../shared/queries/customers.queries";
import { RouteError } from "../../../shared/components/RouteError";
import { RoutePending } from "../../../shared/components/RoutePending";
import { listSearch } from "../../../shared/utils/pagination-search";

const searchSchema = listSearch.extend({
  documentTypeId: z.string().optional(),
  customerId: z.string().optional(),
});

export const Route = createFileRoute("/app/admin/fsm/transitions/")({
  validateSearch: searchSchema,
  errorComponent: ({ error }) => <RouteError error={error} />,
  pendingComponent: RoutePending,
  loader: async ({ context }) => {
    const [customers, states, documentTypes] = await Promise.all([
      context.queryClient.ensureQueryData(customersQueries.list()),
      context.queryClient.ensureQueryData(statesQueries.list()),
      context.queryClient.ensureQueryData(
        documentTypesQueries.list({ pageSize: 500 }),
      ),
    ]);
    return { customers, states, documentTypes };
  },
});
